import {VisitAPIDataSource} from '../api/VisitAPIDataSource';
import {mapVisitDTOToModel} from '../mappers/visit.mapper';
import {Visit, VisitFilters} from '../models/visit.model';
import {Pagination} from '../../../Data/types/BaseResponse';

export interface GetVisitsListResult {
  visits: Visit[];
  pagination: Pagination;
}

export class GetVisitsListUseCase {
  async execute (filters: VisitFilters = {}): Promise<GetVisitsListResult> {
    try {
      const result = await VisitAPIDataSource.getVisits(filters);
      const visits = (result.data || []).map(mapVisitDTOToModel);
      return {
        visits,
        pagination: result.pagination || {page: 1, limit: 20, total: 0, totalPages: 1}
      };
    } catch (error) {
      throw error;
    }
  }
}
